'use client';
/**
 * Gets the user's timezone offset - browser only function
 * @returns {string} timezone offset string (e.g. "GMT+01:00")
 * @example
 * const timezoneOffset = getTimezoneOffset(); // "GMT+01:00"
 */
export const getTimezoneOffset = (): string => {
  const date = new Date();
  const offsetMinutes = date.getTimezoneOffset();

  const absOffset = Math.abs(offsetMinutes);
  const hours = Math.floor(absOffset / 60);
  const minutes = absOffset % 60;

  const sign = offsetMinutes > 0 ? '-' : '+';
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `GMT${sign}${formattedHours}:${formattedMinutes}`;
};

export default getTimezoneOffset;
